/**
 * Lightweight observable store for Anagram. No external state lib —
 * dispatching is just a pure reducer + a subscriber list.
 */

import type { OutMsg } from '@sg/shared';
import { initialState, reduce, type Action } from './reducer.js';
import type { BrowserState } from './types.js';

export type Listener = (next: BrowserState, prev: BrowserState) => void;

export class Store {
  private state: BrowserState = initialState();
  private listeners = new Set<Listener>();

  getState(): BrowserState {
    return this.state;
  }

  dispatch(action: Action): void {
    const prev = this.state;
    const next = reduce(prev, action);
    if (next === prev) return;
    this.state = next;
    for (const l of this.listeners) {
      try {
        l(next, prev);
      } catch (err) {
        console.error('[an-store] listener threw:', err);
      }
    }
  }

  dispatchWs(msg: OutMsg): void {
    this.dispatch({ type: 'ws', msg });
  }

  subscribe(l: Listener): () => void {
    this.listeners.add(l);
    return () => this.listeners.delete(l);
  }
}
